var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTieLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40,
      strokeLinejoin: "round"
    },
    d: "M 163.774 21.082 L 252.379 157.152 L 337.619 21.082 L 163.774 21.082 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40,
      strokeLinejoin: "round"
    },
    d: "M 248.569 141.421 C 248.569 141.421 100 357.783 100 397.426 C 100 417.593 251.108 478.323 251.108 478.323 C 251.108 478.323 400 418.308 400 397.426 C 400 358.414 248.569 141.421 248.569 141.421 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTieLogo);
export default __webpack_public_path__ + "static/media/tieLogo.c741920a82647eda3030bafb1630998f.svg";
export { ForwardRef as ReactComponent };